import { createContext } from 'react';
import { EditorStateContextType } from '../../types';

export const EditorStateContext = createContext<
  Partial<EditorStateContextType>
>({});
EditorStateContext.displayName = 'EditorStateContext';
